import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { RootState } from 'reducers/types';
import { getCurrency } from 'selectors';

import { FormattedAmount } from '../FormattedAmount';

type RoundProps = ConnectedProps<typeof connector> & {
  currency: string;
  value: number;
};
function RoundComponent({ getCurrency, currency, value }: RoundProps) {
  const { unitsToRound, subunitToUnit } = getCurrency(currency);
  const roundedSubunits = unitsToRound * subunitToUnit;
  const roundedValue = Math.round(value * roundedSubunits) / roundedSubunits;

  return <FormattedAmount currency={currency} value={roundedValue} />;
}

const mapStateToProps = (state: RootState) => ({
  getCurrency: (code: string) => getCurrency(state, code),
});

const connector = connect(mapStateToProps);
const Round = connector(RoundComponent);

export { Round };
